import React from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../tables/Table';
import Pagination from "../tables/Pagination";
import useCustomTable from '../tables/useCustomTable';
import * as Format from "../Format";

const DataByDayTable = ({data}) => {
  const { t } = useTranslation();
  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {date: 'desc'}
  });
  const columns = [{
    Header: 'Date',
    accessor: 'date',
    format: 'date'
  },{
    Header: t("dataByDay.devices"),
    accessor: 'active_devices',
  },{
    Header: t("dataByDay.geolocatedDevices"),
    accessor: 'location_authorized_devices',
  },{
    Header: t("dataByDay.optIn"),
    Cell: ({row}) => <Format.Percent value={row.original.opt_in * 100}/>,
    accessor: 'opt_in',
  },{
    Header: t("dataByDay.consented_devices"),
    accessor: 'consented_devices',
  },{
    Header: t("dataByDay.consent"),
    Cell: ({row}) => <Format.Percent value={row.original.consent * 100}/>,
    accessor: 'consent',
  },{
    Header: t("dataByDay.loc_consented_devices"),
    accessor: 'loc_consented_devices',
  },{
    Header: t("dataByDay.geolocated_devices_consented"),
    Cell: ({row}) => <Format.Percent value={row.original.geolocated_devices_consented * 100}/>,
    accessor: 'geolocated_devices_consented',
  },{
    Header: t("dataByDay.globalOptIn"),
    Cell: ({row}) => <Format.Percent value={row.original.global_opt_in * 100}/>,
    accessor: 'global_opt_in',
  }
  ];
  return (<>
    <Table noPadding data={data} columns={columns} {...tableProps} />
    <Pagination {...paginationProps}/>
  </>)
}

export default DataByDayTable
